import { TextField } from "react-admin";

import { DataKind } from "../../types";
import { CustomDateTimeField, CustomShow, ShowTable } from "../custom";

function DemoProjectUserShow() {
  return (
    <CustomShow
      checkPermissionFor={DataKind.DemoProjectTemplate}
      displayDelete={true}
      displayEdit={true}
    >
      <ShowTable title="Demo Project User Details">
        <TextField label="Id" source="id" />
        <TextField label="Demo Project User Id" source="demo_project_user_id" />
        <TextField
          label="Demo Project Shadow User Id"
          source="demo_project_shadow_user_id"
        />
        <CustomDateTimeField label="Created At" source="created_at" />
        <CustomDateTimeField label="Updated At" source="updated_at" />
      </ShowTable>
    </CustomShow>
  );
}

export default DemoProjectUserShow;
